import React from "react";
import jta from "../../../../assets/jta.png";
import { Link } from "react-router-dom";

const Newfooter = () => {
  return (
    <div className=" text-zinc-950  w-full bg-white rounded-none ">
      <div className="relative mt-5 flex w-full flex-col items-center justify-center">
        <div className="z-10 flex flex-col gap-5">
          <p className="px-[10%] text-center font-medium text-4xl text-zinc-900 tracking-tight lg:px-[20%] xl:px-[15%] lg:text-[54px] lg:leading-[68px]">
            Make customer experience your competitive edge
          </p>
          <p className="px-[7%] text-center font-normal text-base text-zinc-600 lg:px-[28%] xl:px-[20%] lg:text-xl lg:leading-7">
            Use JAANO AI to deliver exceptional support experiences that set you
            apart from the competition.
          </p>
        </div>
        <div className="z-10 mt-5 flex w-full flex-col flex-wrap items-center justify-center gap-2 lg:mt-8 lg:mb-[-150px] xl:mb-[-250px]">
          <Link to="/login">
            <div className="relative mb-2 inline-block">
              <div className="absolute bottom-2 h-4 w-full translate-y-full rounded-b-lg bg-gradient-to-r from-[#FB923C] via-[#F472B6] to-[#E879F9]"></div>
              <button className="inline-flex items-center justify-center whitespace-nowrap font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-80 shadow  relative h-14 w-full rounded-md py-6 px-20 lg:px-10 text-base before:bg-gradient-to-r before:from-[#E879F9] before:via-[#F472B6] before:to-[#FB923C] bg-zinc-950 text-white hover:bg-zinc-900 2xl:text-lg">
                Build your Chatbot
              </button>
            </div>
          </Link>
        </div>
        <img
          alt="jta"
          loading="lazy"
          width="2752"
          height="574"
          data-nimg="1"
          className="relative z-0 w-full"
          src={jta}
        />
      </div>
    </div>
  );
};

export default Newfooter;
